module.exports = __webpack_public_path__ + "static/media/seriousCallDoctor.06793567.mp3";